import React from "react";
import { StyledCell, StyledHeader, StyledRow, StyledTable } from "styles/components/Table.styles";
import useMRFTranslation from "mrf/utils/useMRFTranslation";
import AccordionRow from "mrf/view/AccordionRow";
import { useMemo } from "react";
import If from "mrf/utils/If";

function AccordionTable({
    contentList,
    contentFields,
    accordionContentFields,
    accordionContentsKey,
    emptyListLabel = 'This table is empty',
    displayAccordionTitle = "Show contents",
    displayAccordionTooltip = "Show contents"
}) {
    const t = useMRFTranslation();

    const cols = contentFields.length;

    const emptyListLabelWrapper = useMemo(() =>
        <StyledRow align='center'><StyledCell colSpan={cols}>{t(emptyListLabel)}</StyledCell></StyledRow>,
        [t, cols, emptyListLabel]
    );

    return <>
        <StyledTable>
            <thead>
                <StyledRow>
                    {contentFields.map((field, idx) => (
                        <StyledHeader>
                            {t(field.name)}
                        </StyledHeader>
                    ))}
                    <StyledHeader>
                        {t(displayAccordionTitle)}
                    </StyledHeader>
                </StyledRow>
            </thead>
            <tbody>
                <If condition={contentList?.length !== 0} alt={emptyListLabelWrapper}>
                    {contentList?.map(content => (
                        <AccordionRow
                            rowContent={content}
                            rowContentFields={contentFields}
                            accordionContentFields={accordionContentFields}
                            accordionContents={content?.[accordionContentsKey] ?? []}
                            displayAccordionTooltip={displayAccordionTooltip}
                        />
                    ))}
                </If>
            </tbody>
        </StyledTable>
    </>
}

export default AccordionTable;